import React__default, { lazy, Suspense } from "react";
const Thrive = lazy(
  () => import("./thrive-primary.B4CPQt3N.mjs")
);
const Academy = lazy(
  () => import("./academy-primary.D9dNlii0.mjs")
);
const Atlas = lazy(
  () => import("./atlas-primary.4tZDr0EW.mjs")
);
const Bloom = lazy(
  () => import("./bloom-primary.D0SmOfkJ.mjs")
);
const Mind = lazy(() => import("./mind-primary.rrzO05QG.mjs"));
const Move = lazy(() => import("./move-primary.CHDXG_ae.mjs"));
const OnCall = lazy(
  () => import("./on-call-primary.6ezTB8XH.mjs")
);
const Predict = lazy(
  () => import("./predict-primary.C5N_Av1_.mjs")
);
const ThriveSymbol = lazy(
  () => import("./thrive-symbol-primary.CUgRQLsB.mjs")
);
const AcademySymbol = lazy(
  () => import("./academy-symbol-primary.CL1y92mf.mjs")
);
const AtlasSymbol = lazy(
  () => import("./atlas-symbol-primary.DGmNw9Cp.mjs")
);
const BloomSymbol = lazy(
  () => import("./bloom-symbol-primary.fiZCDDOB.mjs")
);
const MindSymbol = lazy(
  () => import("./mind-symbol-primary.Cg5flk2-.mjs")
);
const MoveSymbol = lazy(
  () => import("./move-symbol-primary.BAPqfUe2.mjs")
);
const OnCallSymbol = lazy(
  () => import("./on-call-symbol-primary.CYOpcnPF.mjs")
);
const PredictSymbol = lazy(
  () => import("./predict-symbol-primary.DL0T0-xS.mjs")
);
const SOLUTION_LOGO_VARIANTS = ["primary", "symbol-primary"];
const Logo = ({ solution, ...props }) => {
  switch (solution) {
    case "thrive":
      return /* @__PURE__ */ React__default.createElement(Thrive, { ...props });
    case "academy":
      return /* @__PURE__ */ React__default.createElement(Academy, { ...props });
    case "atlas":
      return /* @__PURE__ */ React__default.createElement(Atlas, { ...props });
    case "bloom":
      return /* @__PURE__ */ React__default.createElement(Bloom, { ...props });
    case "mind":
      return /* @__PURE__ */ React__default.createElement(Mind, { ...props });
    case "move":
      return /* @__PURE__ */ React__default.createElement(Move, { ...props });
    case "on-call":
      return /* @__PURE__ */ React__default.createElement(OnCall, { ...props });
    case "predict":
      return /* @__PURE__ */ React__default.createElement(Predict, { ...props });
    default:
      return null;
  }
};
const Symbol$1 = ({ solution, ...props }) => {
  switch (solution) {
    case "thrive":
      return /* @__PURE__ */ React__default.createElement(ThriveSymbol, { ...props });
    case "academy":
      return /* @__PURE__ */ React__default.createElement(AcademySymbol, { ...props });
    case "atlas":
      return /* @__PURE__ */ React__default.createElement(AtlasSymbol, { ...props });
    case "bloom":
      return /* @__PURE__ */ React__default.createElement(BloomSymbol, { ...props });
    case "mind":
      return /* @__PURE__ */ React__default.createElement(MindSymbol, { ...props });
    case "move":
      return /* @__PURE__ */ React__default.createElement(MoveSymbol, { ...props });
    case "on-call":
      return /* @__PURE__ */ React__default.createElement(OnCallSymbol, { ...props });
    case "predict":
      return /* @__PURE__ */ React__default.createElement(PredictSymbol, { ...props });
    default:
      return null;
  }
};
const SolutionLogo = ({
  placeholder,
  variant = "primary",
  height = 80,
  width,
  ...props
}) => {
  return /* @__PURE__ */ React__default.createElement(Suspense, { fallback: placeholder || /* @__PURE__ */ React__default.createElement("div", { style: { height } }) }, variant === "primary" && /* @__PURE__ */ React__default.createElement(
    Logo,
    {
      ...props,
      "aria-hidden": "true",
      "data-testid": props.solution,
      height,
      width
    }
  ), variant === "symbol-primary" && /* @__PURE__ */ React__default.createElement(
    Symbol$1,
    {
      ...props,
      "aria-hidden": "true",
      "data-testid": props.solution,
      height,
      width
    }
  ));
};
export {
  SOLUTION_LOGO_VARIANTS as S,
  SolutionLogo as a
};
//# sourceMappingURL=SolutionLogo.Cu7IPBCl.mjs.map
